import { render, staticRenderFns } from "./detailv2.vue?vue&type=template&id=683a68ec&scoped=true"
import script from "./detailv2.vue?vue&type=script&lang=js"
export * from "./detailv2.vue?vue&type=script&lang=js"
import style0 from "./detailv2.vue?vue&type=style&index=0&id=683a68ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683a68ec",
  null
  
)

export default component.exports